import {
    BYOButton,
    ContentCard,
    Paragraph,
} from '@cdm/quickenloans-library/lib';
import ArrowForward from '@mui/icons-material/ArrowForward';
import PropTypes from 'prop-types';
import React from 'react';
import LearningCenterSourceIdLink from '../LearningCenterSourceIdLink';
import {
    actions,
    content,
    headline,
    imageContainer,
    singleCtaContainer,
    variant,
    wrapper,
} from './ArticleSingleCta.module.scss';
import { defaultAttributes, testAttributes } from './Constants';

const ArticleSingleCta = ({
    icon = '',
    title = '',
    description = '',
    buttonText = '',
    href = '',
    articleId = '',
    buttonIcon = null,
    buttonAttributes = { target: '_blank' },
    headline: { Component: Headline } = { Component: false },
    type = 'old',
    buttons = [],
}) =>
{
    const ctaRightIcon =
        buttonIcon !== null ? buttonIcon || <ArrowForward /> : null;
    const renderContent = () =>
    {
        if (type === 'new')
        {
            return (
                <ContentCard
                    testId={testAttributes.CTA_BLOCK_CONTAINER}
                    className={`${singleCtaContainer} ${variant}`}
                >
                    <section className={`noMargin ${wrapper} ${variant}`}>
                        <section
                            className={`${content}`}
                            data-testid={
                                testAttributes.SINGLE_CTA_HEADING_CONTAINER
                            }
                        >
                            <section className={`${headline}`}>
                                {Headline && <Headline
                                    className="h3_semi_bold_newSize"
                                    testId={testAttributes.SINGLE_CTA_HEADING}
                                >
                                    {title}
                                </Headline>}
                                <Paragraph className="para_regular_newSize">{description}</Paragraph>
                            </section>
                            <section className={`${actions}`}>
                                {buttons && buttons.map(item => (
                                    <BYOButton
                                        as={LearningCenterSourceIdLink}
                                        color={defaultAttributes.color}
                                        style={!item?.buttonClasses?.includes(testAttributes.VARIANT_OUTLINED) ? defaultAttributes.filled : defaultAttributes.outlined}
                                        href={href}
                                        articleId={articleId}
                                        testId={testAttributes.SINGLE_CTA_BUTTON}
                                        iconRight={item.buttonIcon}
                                        iconTestId={testAttributes.SINGLE_CTA_BUTTON_ICON}
                                        {...buttonAttributes}
                                    >
                                        {item.buttonText}
                                    </BYOButton>
                                ))}
                            </section>
                        </section>
                        <section className={imageContainer}>
                            {icon && (
                                <img
                                    alt={title}
                                    src={icon}
                                    itemProp="image"
                                    data-testid={
                                        testAttributes.SINGLE_CTA_IMAGE
                                    }
                                />
                            )}
                        </section>
                    </section>
                </ContentCard>
            );
        }
        return (
            <ContentCard
                testId={testAttributes.SINGLE_CTA_CONTAINER}
                className={singleCtaContainer}
            >
                <div className={`noMargin ${wrapper}`}>
                    <div
                        data-testid={
                            testAttributes.SINGLE_CTA_HEADING_CONTAINER
                        }
                    >
                        {icon && (
                            <img alt={title} src={icon} itemProp="image" />
                        )}
                        {Headline && <Headline testId={testAttributes.SINGLE_CTA_HEADING}>
                            {title}
                        </Headline>}
                    </div>
                    {description}
                    {buttonText && (
                        <BYOButton
                            as={LearningCenterSourceIdLink}
                            color={defaultAttributes.color}
                            style={defaultAttributes.filled}
                            href={href}
                            articleId={articleId}
                            testId={testAttributes.SINGLE_CTA_BUTTON}
                            iconRight={ctaRightIcon}
                            iconTestId={testAttributes.SINGLE_CTA_BUTTON_ICON}
                            {...buttonAttributes}
                        >
                            {buttonText}
                        </BYOButton>
                    )}
                </div>
            </ContentCard>
        );
    };

    return renderContent();
};

ArticleSingleCta.propTypes = {
    /** Icon, heading icon */
    icon: PropTypes.string,
    /** Title, CTA card title */
    title: PropTypes.string,
    /** Description, CTA card content description */
    description: PropTypes.node,
    /** ButtonText, CTA card button label */
    buttonText: PropTypes.string,
    /** Learning center href, CTA card url */
    href: PropTypes.string,
    /** Article identifier */
    articleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** Icon for the button */
    buttonIcon: PropTypes.object,
    /** Additional attributes for the button, e.g. target="_blank", rel="nofollow" */
    buttonAttributes: PropTypes.object,
    /** Dynamic heading headline */
    headline: PropTypes.shape({
        Component: PropTypes.elementType,
    }).isRequired,
    /** Type of CTA */
    type: PropTypes.string,
    /** Buttons, CTA card buttons */
    buttons: PropTypes.array,
};

export default ArticleSingleCta;
